import { createLinearChartReducer } from 'features/dashboard/redux/createLinearChartReducer';

export const redemptionsGraph = createLinearChartReducer('redemptionsGraph', '/orders/redemptions-graph/');
